// extracted by mini-css-extract-plugin
module.exports = {"exception":"style_exception__19KRd","trigger":"style_trigger__2Yw03"};